var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.874,
    height: 29.874,
    viewBox: "0 0 29.874 29.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1165976",
    "data-name": "Group 1165976",
    transform: "translate(-1195.069 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_broken_notification-bing",
    "data-name": "vuesax/broken/notification-bing",
    transform: "translate(1087.069 -148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-bing",
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0V4.145",
    transform: "translate(14.937 8.016)",
    fill: "none",
    stroke: "#0f1322",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M21.773,16.393a2.763,2.763,0,0,1-1.494,4.045,29.052,29.052,0,0,1-18.335,0A2.648,2.648,0,0,1,.45,16.393l1.581-2.639a6.509,6.509,0,0,0,.784-2.838V8.3A8.29,8.29,0,1,1,19.4,8.29V10.9a5.314,5.314,0,0,0,.062.734",
    transform: "translate(3.857 2.49)",
    fill: "none",
    stroke: "#0f1322",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M8.29,0A4.16,4.16,0,0,1,4.145,4.145,4.152,4.152,0,0,1,1.22,2.925,4.152,4.152,0,0,1,0,0",
    transform: "translate(10.792 23.426)",
    fill: "none",
    stroke: "#0f1322",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H29.874V29.874H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiIcon);
export default __webpack_public_path__ + "static/media/noti_icon.0b5990463eff49ad635e85d0cdf5aea8.svg";
export { ForwardRef as ReactComponent };